export const CONTACT_FORM_EN = {
  contactForm: 'Contact Form',
  contactFormTitle: 'Contact Us',
  contactFormSubtitle:
    "Have a question or need assistance? Fill out the form below and we'll get back to you soon.",
  contactFormSelectTopic: 'Select Topic',
  contactFormName: 'Name',
  contactFormEmail: 'Email',
  contactFormMessage: 'Message',
  contactFormSendButton: 'Send',
  contactFormSendingButton: 'Sending...',
  contactFormSuccess: 'Thank you! Your message has been sent successfully.',
  contactFormError: 'Sorry, something went wrong. Please try again later.'
}

export const CONTACT_FORM_DE = {
  contactForm: 'Kontaktformular',
  contactFormTitle: 'Kontaktieren Sie uns',
  contactFormSubtitle:
    'Haben Sie eine Frage oder benötigen Sie Hilfe? Füllen Sie das Formular aus und wir melden uns bald bei Ihnen.',
  contactFormSelectTopic: 'Thema auswählen',
  contactFormName: 'Name',
  contactFormEmail: 'E-Mail',
  contactFormMessage: 'Nachricht',
  contactFormSendButton: 'Senden',
  contactFormSendingButton: 'Wird gesendet...',
  contactFormSuccess: 'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.',
  contactFormError:
    'Entschuldigung, etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal.'
}
